<template>
  <div>

    <!-- index banner -->
    <div class="banner">
      <el-carousel indicator-position="outside" arrow="never">
        <el-carousel-item v-for="item in bannerImageArray" :interval="10000" :key="item.id">
          <h3><img :src="downloadFileURL+item.imageUrl+'/'" /></h3>
        </el-carousel-item>
      </el-carousel>
      <!-- <div class="side_banner">
        <h2>注册有好礼</h2> -->
        <!-- <el-tooltip class="gift" effect="dark" content="解释权归普惠投融所有" placement="right">
          <el-button type="text">iPhoneX一部先到先得</el-button>
        </el-tooltip> -->
        <!-- <img src="../assets/images/qrcode_login.jpg" />
        <p>微信扫码注册</p>
        <el-button type="primary" @click="register">立即注册</el-button>
      </div> -->
      <!--首页banner统计-->
      <!-- <div class="data_banner" v-html="bodyDefaultMsg"></div> -->
    </div><!-- index banner END -->

    <!-- index news -->
    <div class="news_index">
      <div class="news_index_inner">
        <el-row class="in_notice">
          <el-col :span="20">
            <span class="index_news_title">通知公告</span>
            <div class="inews">
              <div :style="{ top }" class="inews_inner" :class="{anim:animate==true}">
                <a v-for="item in notificationAnnouncementArray" v-on:click="toNotificationAnnouncement(item.id)">{{item.title}}</a>
              </div>
            </div>
          </el-col>
          <el-col :span="4">
            <router-link :to="{path:'notificationAnnouncement'}" class="in_more">查看更多</router-link>
          </el-col>
        </el-row>
        <el-row class="news_panel">
          <el-col :span="12">
            <el-carousel :interval="5000" class="inews_left">
              <el-carousel-item v-for="item in focusNewsImagesArray " :key="item.id">
               <img v-on:click="toCenterNewsDetail(item.id)" :src="downloadFileURL+item.imageUrl+'/'"/>
                <a v-on:click="toCenterNewsDetail(item.id)" class="inews_left">{{item.title}}</a>
              </el-carousel-item>
            </el-carousel>
          </el-col>
          <el-col :span="11" :offset="1">
            <h1>
              <a class="title_inews" v-on:click="toReferenceCenterAnyWhereDetail(focusTitle.id,focusTitle.publishType)">{{focusTitle.title}}</a>
            </h1>
            <ul>
              <li v-for="item in focusTitleArray" :key="item.id"><span>{{item.publishTime|date_from_unix_YearMonthDay}}</span><a v-on:click="toReferenceCenterListByPublishType(item.publishType)">[{{item.publishType}}]</a><a v-on:click="toReferenceCenterAnyWhereDetail(item.id,item.publishType)">{{item.title}}</a></li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- index news END-->

    <div class="news_index">
      <div class="news_index_inner">
        <img src="../assets/images/ad_for_out_new.png" width="100%"/>
      </div>
    </div>
    <!-- index big btns -->
    <!-- <div class="index_big_btns">
      <el-row type="flex" justify="space-between" class="ib_panel">
        <el-col :span="8">
          <router-link :to="{ path: '/borrowProject' }">
            <i class="iconfont">&#xe736;</i>
            <h4>借入服务</h4>
            <p>拓展融资渠道，助力企业发展</p>
          </router-link>
        </el-col>
        <el-col :span="8">
          <router-link :to="{ path: '/loanProject' }">
            <i class="iconfont">&#xe735;</i>
            <h4>出借服务</h4>
            <p>规范民间借贷，盘活民间资本</p>
          </router-link>
        </el-col>
        <el-col :span="8">
          <router-link :to="{ path: '/assignmentDebt' }">
            <i class="iconfont">&#xe725;</i>
            <h4>债权转让服务</h4>
            <p>灵活资产配置，方便资金周转</p>
          </router-link>
        </el-col>
        <el-col :span="8">
          <router-link :to="{ path: '/ecInvestmentIntroduction' }">
            <i class="iconfont">&#xe738;</i>
            <h4>股权/基金投资服务</h4>
            <p>引入实力投资，助推企业发展</p>
          </router-link>
        </el-col>
      </el-row>
    </div> -->
    <!-- index big btns END-->

    <!-- index lists -->
    <!-- <div class="index_lists">
      <div class="index_lists_inner">
        <h3>
          借入信息
          <img src="../assets/images/img_ad_title.png" />
          <router-link :to="{name: 'borrowProject'}">更多借入信息</router-link>
        </h3>
        <div class="ilist">
          <el-table :data="borrowProjectArray" style="width: 100%">
              <el-table-column prop="" label="项目名称" width="290">
                <template slot-scope="scope">
                  {{scope.row.projectName}}: {{scope.row.projectCode}}
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="借入金额(元)" width="120" align="center"></el-table-column>
              <el-table-column prop="yieldRate" label="预期收益率(年化)" width="180" align="center" :formatter="formatYieldRate" class-name="light_tbl"></el-table-column>
              <el-table-column prop="deadline" label="借款期限(天)" width="100" align="center"></el-table-column>
              <el-table-column prop="guaranteeMethodNames" label="保证方式" width="200"></el-table-column>
              <el-table-column prop="realTimeStatusName" label="实时状态" width="120" align="center" :formatter="getRealTimeStatsName"></el-table-column>
              <el-table-column label="" align="center">
                <template slot-scope="scope">
                <el-button size="small"  @click="goBorrowProjectDetail(scope.$index,scope.row)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
        </div>
        <h3>
          出借信息
          <img src="../assets/images/img_ad_title2.png" />
          <router-link :to="{name: 'loanProject'}">更多出借信息</router-link>
        </h3>
        <div class="ilist">
          <el-table :data="loanProjectArray" style="width: 100%">
            <el-table-column prop="lenders" label="出借方" width="130"></el-table-column>
            <el-table-column prop="amount" label="出借金额(元)" width="150" align="center"></el-table-column>
            <el-table-column prop="yieldRate" label="期望收益率(年化)" width="200" align="center" :formatter="formatYieldRate" class-name="light_tbl"></el-table-column>
            <el-table-column prop="deadline" label="出借期限(天)" width="120" align="center"></el-table-column>
            <el-table-column prop="guaranteeMethodNames" label="要求保证方式" width="300"></el-table-column>
            <el-table-column prop="realTimeStatusName" label="实时状态" width="120" align="center" :formatter="getRealTimeStatsName"></el-table-column>
            <el-table-column label="">
              <template slot-scope="scope">
              <el-button size="small"  @click="goLanProjectDetail(scope.$index,scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog width="640px" title="提示消息" :visible.sync="dialogProjectVisible" top="36vh" center>
      <el-row>
        <el-col>
          温馨提示：尊敬的访客，您好！您需要注册普惠借贷平台账户并登录成功后才能查看项目详情。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="getRegister">立即注册</el-button>
          <el-button @click="goLogin">直接登录</el-button>
      </span>
    </el-dialog> -->
    <!-- index lists END-->

    <!-- index downloads -->
    <!-- <div class="index_downloads">
      <el-row class="id_btns">
        <el-col :span="12">
          <a class="ibtn_in" href="#" @click="getDialogBorrow">
            <h3>我要借入<i class="iconfont">&#xe697;</i></h3>
            <p>抵押、质押专业担保</p>
          </a>
        </el-col>
        <el-col :span="12">
          <a class="ibtn_out" href="#" @click="getDialogLan">
            <h3>我要出借<i class="iconfont">&#xe697;</i></h3>
            <p>自有资金、灵活配置</p>
          </a>
        </el-col>
      </el-row>
      <div class="idownload">
        <el-row>
          <router-link :to="{ path: '/dataDownload'}">
          <el-col :span="6" class="id_left">
            <i class="iconfont">&#xe72e;</i>
            <h4>下载资料</h4>
          </el-col>
          </router-link>
          <el-col :span="18" class="index_down_data">
            <el-row >
                    <el-col :span="8" v-for="file in fileManagementArray" :key="file.id">
                      <a :href="file.fileUrl">
                        <i class="iconfont ico_doc">&#xe8ac;</i>
                        <h5>{{file.fileName}}</h5>
                        <p>{{file.fileType}} &nbsp;&nbsp;{{file.fileSize}}</p>
                        <i class="iconfont icon_index_download">&#xe60c;</i>
                      </a>
                    </el-col>


            </el-row>
          </el-col>
        </el-row>
      </div>
    </div> -->

    <!-- index direct borrow intention -->
    <el-dialog title="借入意向" width="640px" :visible.sync="dialogFormBorrowVisible" center>
      <el-form ref="addBorrowForm" :model="addBorrowForm" :rules="addFormRules">
        <el-form-item label="主体" prop="main" :label-width="formLabelWidth">
          <el-select v-model="addBorrowForm.main" placeholder="请选择主体">
            <el-option
                    v-for="item in mainDictionaryArray"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人姓名:" prop="name" :label-width="formLabelWidth">
          <el-input v-model="addBorrowForm.name" auto-complete="off" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="sex" :label-width="formLabelWidth">
          <el-radio-group v-model="addBorrowForm.sex" class="el-input">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="期望年化利率(%):" prop="interestRate" :label-width="formLabelWidth">
          <el-input v-model="addBorrowForm.interestRate" placeholder="请输入期望年化利率(最多两位小数)" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="金额(元):" prop="amount" :label-width="formLabelWidth">
          <el-input v-model="addBorrowForm.amount" placeholder="请输入金额" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="期限(天):" prop="deadline" :label-width="formLabelWidth">
          <el-input v-model="addBorrowForm.deadline" placeholder="请输入期限" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" prop="mobile" :label-width="formLabelWidth">
          <el-input v-model="addBorrowForm.mobile" placeholder="请输入联系电话" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="addBorrowForm.remark" :rows="4" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="图形验证码:" prop="codeImg" :label-width="formLabelWidth">
          <el-input v-model="addBorrowForm.codeImg" :disabled="inputCodeImage" auto-complete="off" placeholder="请输入图形验证码"></el-input>
          <img id="imgCode" class="img_code" src="" v-bind:class="{disabledChangeCodeImage:clickCodeImage}" @click="getBorrowIntentionCode"/>
        </el-form-item>
        <el-form-item label="手机验证码:" prop="phoneCaptcha" :label-width="formLabelWidth">
          <el-input v-model="addBorrowForm.phoneCaptcha" placeholder="请输入手机验证码"></el-input>
          <el-button v-bind:class="{transparent:showPhoneCaptchaButton}" type="default" class="btn_login_msg" @click="getPhoneCaptcha">{{btntxt}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormBorrowVisible=false">取 消</el-button>
        <el-button type="primary" @click="getBorrowIntention">提 交</el-button>
      </span>
    </el-dialog>
    <!-- index direct borrow intention END -->

    <!-- index direct lend intention -->
    <el-dialog title="出借意向" width="640px" :visible.sync="dialogFormLanVisible" center>
      <el-form ref="addLanForm" :model="addLanForm" :rules="addFormRules">
        <el-form-item label="姓名:" prop="name" :label-width="formLabelWidth">
          <el-input v-model="addLanForm.name" auto-complete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="sex" :label-width="formLabelWidth">
          <el-radio-group v-model="addLanForm.sex" class="el-input">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="期望年化利率(%):" prop="interestRate" :label-width="formLabelWidth">
          <el-input v-model="addLanForm.interestRate" placeholder="请输入期望年化利率(最多两位小数)" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="金额(元):" prop="amount" :label-width="formLabelWidth">
          <el-input v-model="addLanForm.amount" placeholder="请输入金额" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="期限(天):" prop="deadline" :label-width="formLabelWidth">
          <el-input v-model="addLanForm.deadline" placeholder="请输入期限" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" prop="mobile" :label-width="formLabelWidth">
          <el-input v-model="addLanForm.mobile" placeholder="请输入联系电话" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="addLanForm.remark" :rows="4" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="图形验证码:" prop="codeImg" :label-width="formLabelWidth">
          <el-input v-model="addLanForm.codeImg" :disabled="inputLanCodeImage" auto-complete="off" placeholder="请输入图形验证码"></el-input>
          <img id="loanIntentionImgCode"  v-bind:class="{disabledChangeCodeImage:clickCodeImage}" class="img_code" src="" @click="getLanIntentionCode"/>
        </el-form-item>
        <el-form-item label="手机验证码:" prop="phoneCaptcha" :label-width="formLabelWidth">
          <el-input v-model="addLanForm.phoneCaptcha" placeholder="请输入手机验证码"></el-input>
          <el-button v-bind:class="{transparent:showPhoneCaptchaButton}" type="default" class="btn_login_msg" @click="getLoanPhoneCaptcha">{{btntxt}}</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormLanVisible = false">取 消</el-button>
        <el-button type="primary" @click="getLanIntention">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 弹出层 -->
    <el-dialog title="提示消息" :visible.sync="dialogMsgVisible">
      <el-row>
        <el-col>
          温馨提示：您的借贷意向已经成功发送，平台将会在24小时内主动和您取得联系。或者，您还可以拨打我们的服务热线 400 029 7800 线下办理借贷业务。
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogMsgVisible=false">确定</el-button>
            </span>
    </el-dialog>
    <!-- index direct lend intention END-->

    <!-- index knowledge -->
    <div class="index_knowledge">
      <el-row type="flex" justify="space-between" class="ik_inner">
        <el-col :span="12">
          <h3>政策法规<router-link :to="{path:'policiesRegulations'}">更多<i class="el-icon-d-arrow-right"></i></router-link></h3>
          <ul>
            <li v-for="item in policiesRegulationsArray" :key=item.id><a v-on:click="toPoliciesRegulationsDetail(item.id)">{{item.title}}</a></li>
          </ul>
        </el-col>
        <el-col :span="12">
          <h3>借贷知识<router-link :to="{path:'borrowingKnowledge'}">更多<i class="el-icon-d-arrow-right"></i></router-link></h3>
          <ul>
            <li v-for="item in borrowingKnowledgeArray" :key="item.id"><a v-on:click="toBorrowingKnowledgeDetail(item.id)">{{item.title}}</a></li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <!-- index knowledge END-->

    <!-- index partner -->
    <div class="index_partner">
      <h3>合作机构<router-link :to="{path:'cooperativePartner'}">更多<i class="el-icon-d-arrow-right"></i></router-link></h3>
      <div class="ip_inner" v-html="homePagePartnerHtml">
      </div>
    </div>
    <!-- index partner END -->

  </div>
</template>

<script>
import {reqGetDictionaryListByCode,reqDirectBorrowIntentionAdd,reqDirectBorrowIntentionCodeImg,
    downloadFileURL,reqDirectLoanIntentionAdd,reqDirectIntentionPhoneCaptcha,reqDirectIntentionCodeImgIsTrue,reqDirectLanIntentionCodeImg,reqDirectLanIntentionCodeImgIsTrue,reqDirectLanIntentionPhoneCaptcha} from '../api/intentionManagement-api';
import {reqBannerImage,reqFocusNewsImages,reqNotificationAnnouncement,reqFocusTitle,reqPoliciesRegulations,reqReferenceCenterPublishTypeCount} from '../api/system-api';
import {reqGetTopNBorrowProjects,reqGetTopNLoanProjects,reqValidateWebUser} from '../api/projectManagement-api';
import {reqBannerStatistical,reqHomePagePartner,reqFileManagementList} from '../api/contentManagement-api'
//  const stringWidth = require('string-width');
  export default {
      data () {
        var checkInteger= (rule, value, callback) => {
            var reg = /^[0-9]*$/;
            if (!value) {
                return callback(new Error('请输入'+rule.label));
            }
            if (reg.test(value)) {
                if(value.toString().length>rule.length)
                    callback(new Error(rule.label+'不能超过'+rule.overlengthMsg));
                else
                    callback();
            } else {
                callback(new Error(rule.label+'格式不正确'));
            }
        };

        var checkAmount= (rule, value, callback) => {
            var reg =/^\d+(\.\d{1,2})?$/;
                if (!value) {
                    return callback(new Error('请输入'+rule.label));
                }
                if (reg.test(value)) {
                    if(value.toString().length>rule.length)
                        callback(new Error(rule.label+'不能超过'+rule.overlengthMsg));
                    else
                        callback();
                } else {
                    callback(new Error(rule.label+'格式不正确'));
                }
            };

        return {
          fileManagementArray:[],
          top:1,
          fileUrl:'',
          dialogMsgVisible:false,
          formLabelWidth:'150px',
          dialogFormBorrowVisible:false,
          dialogFormLanVisible:false,
          mainDictionaryArray:[],
          showPhoneCaptchaButton:false,
          btntxt: '获取短信验证码',
          clickCodeImage:false,
          inputCodeImage:false,
          inputLanCodeImage:false,
          bannerImageArray:[],
          bodyDefaultMsg:'',
          focusNewsImagesArray:[],
          focusNewsImagesCount:'',
          focusTitle:{},
          focusTitleArray:[],
          publishTypeTotal:'',
          dialogProjectVisible:false,
          downloadFileURL:downloadFileURL,
          addBorrowForm: {
              codeImg:'',
              onlyImgCode:'',
              main: '',
              name: '',
              sex: '1',
              interestRate: '',
              amount: '',
              deadline: '',
              mobile: '',
              remark: '',
              onlyPhoneCode:'',
              phoneCaptcha: '',
          },
          addLanForm: {
              codeImg:'',
              onlyImgCode:'',
              name: '',
              sex: '1',
              interestRate: '',
              amount: '',
              deadline: '',
              mobile: '',
              remark: '',
             onlyPhoneCode:'',
              phoneCaptcha:'',
          },
          addFormRules: {
              main: [
                  {required: true, message: '请选择主体',trigger: 'blur'},
              ],
              name: [
                  {required: true, message: '请输入姓名',trigger: 'blur'},
              ],
              sex: [
                  {required: true, message: '请选择性别', trigger: 'blur'},
              ],
              interestRate: [
                  {required: true, trigger: 'blur',validator:checkAmount,label:'期望年化利率',length:'6',overlengthMsg:'6个字符'},
              ],
              amount: [
                  {required: true, trigger: 'blur',validator: checkAmount, label: '金额',length: '10', overlengthMsg:'10个字符'},
              ],
              deadline: [
                  {required: true, trigger: 'blur',validator:checkInteger,label:'期限',length:'4',overlengthMsg:'4个字符'},
              ],
              mobile: [
                  {required: true, message: '请输入联系电话',trigger: 'blur'},
                  {pattern: /^1[3|4|5|7|8|9][0-9]{9}$/, message:'请输入正确的手机号',trigger: 'blur'},
              ],
            remark: [
              {min:1,max:100, message:'备注1-100位',trigger: 'blur'},
            ],
              phoneCaptcha:[
                  {required: true, message: '请输入手机验证码',trigger: 'blur'},
              ],
              codeImg:[
                  {required: true, message: '请输入图形验证码',trigger: 'blur'},
              ]
          },

          //滚动通知
          animate:false,
          notificationAnnouncementArray: [],
          notificationAnnouncementCount:'',
          borrowProjectArray: [],
          loanProjectArray: [],
          policiesRegulationsArray:[],
          policiesRegulationsCount:'',
          borrowingKnowledgeArray:[],
          borrowingKnowledgeCount:'',
          homePagePartnerHtml:'',
        };
      },
      created(){
          setInterval(this.scroll,5000)
      },
      methods: {
          formatYieldRate: function (row, column) {
            return row.yieldRate+'%';
          },
          getDialogBorrow(){
                  this.dialogFormBorrowVisible=true;
                  this.addBorrowForm={sex: '1',};
                  this.addBorrowForm.codeImg='';
                  this.countDownTime = 0;
                  this.btntxt = '获取短信验证码';
                  this.showPhoneCaptchaButton=false;
                  this.clickCodeImage=false;
                  this.inputCodeImage=false;
                  //查询主体
                  reqGetDictionaryListByCode({code:'borrow_body'}).then((res)=>{
                      this.mainDictionaryArray=res.data.data;
                  });
                  this.getBorrowIntentionCode();

          },
          getDialogLan(){
              this.dialogFormLanVisible=true;
              this.addLanForm={sex: '1',};
              this.addLanForm.codeImg='';
              this.countDownTime = 0;
              this.btntxt = '获取短信验证码';
              this.showPhoneCaptchaButton=false;
              this.clickCodeImage=false;
              this.inputLanCodeImage=false;
              this.getLanIntentionCode();

          },

// 获取手机验证码的时候先验证图形验证码
          getPhoneCaptcha:function () {
              this.addBorrowForm.phoneCaptcha='';
              if(this.addBorrowForm.codeImg===''||this.addBorrowForm.codeImg===null) {
                  this.$message({
                      message: '请先输入图形验证码',
                      type: 'warning'
                  });
              }else {
                  reqDirectIntentionCodeImgIsTrue({codeImage:this.addBorrowForm.codeImg,onlyImgCode:this.addBorrowForm.onlyImgCode}).then((res)=>{
                      if(res.data.code!=4){
                          this.$message({
                              message: '图形验证码输入错误',
                              type: 'warning'
                          });
                      }else {
                          this.clickCodeImage=true;
                          this.inputCodeImage=true;
                              reqDirectIntentionPhoneCaptcha({mobile: this.addBorrowForm.mobile}).then((res) => {
                                if(res.data.code === 4){
                                  this.$message({
                                    message: '请输入手机号',
                                    type: 'warning'
                                  });
                                } else if (res.data.code === 3) {
                                      this.$message({
                                          message: '短信验证码发送异常，请稍后重新发送',
                                          type: 'warning'
                                      });
                                  } else if (res.data.code === 2) {
                                      this.$message({
                                          message: '短信验证码发送失败，请稍后重新发送',
                                          type: 'warning'
                                      });
                                  } else if (res.data.code === 1) {
                                      this.addBorrowForm.onlyPhoneCode=res.data.data;
                                      this.showPhoneCaptchaButton = true;
                                      this.countDownTime = 120;
                                      this.timer()
                                  }
                              })
                      }
                  });
              }
          },

          getLoanPhoneCaptcha:function () {
              this.addLanForm.phoneCaptcha='';
              if(this.addLanForm.codeImg===''||this.addLanForm.codeImg===null) {
                  this.$message({
                      message: '请先输入图形验证码',
                      type: 'warning'
                  });
              }else {
                reqDirectLanIntentionCodeImgIsTrue({codeImage:this.addLanForm.codeImg,onlyImgCode:this.addLanForm.onlyImgCode}).then((res)=>{
                      if(res.data.code!=1){
                          this.$message({
                              message: '图形验证码输入错误',
                              type: 'warning'
                          });
                      }else {
                        this.clickCodeImage=true;
                          this.inputLanCodeImage=true;
                            reqDirectLanIntentionPhoneCaptcha({mobile: this.addLanForm.mobile}).then((res) => {
                              if(res.data.code === 4){
                                this.$message({
                                  message: '请输入手机号码',
                                  type: 'warning'
                                });
                              } else if (res.data.code === 3) {
                                      this.$message({
                                          message: '短信验证码发送异常，请稍后重新发送',
                                          type: 'warning'
                                      });
                                  } else if (res.data.code === 2) {
                                      this.$message({
                                          message: '短信验证码发送失败，请稍后重新发送',
                                          type: 'warning'
                                      });
                                  } else if (res.data.code === 1) {
                                    this.addLanForm.onlyPhoneCode=res.data.data;
                                    this.showPhoneCaptchaButton = true;
                                      this.countDownTime = 120;
                                      this.timer()
                                  }
                              })
                      }
                  });
              }
          },

//  手机验证码倒计时
          timer: function () {
              if (this.countDownTime > 0) {
                  this.countDownTime--;
                  this.btntxt = this.countDownTime + 'S';
                  setTimeout(this.timer, 1000)
              } else {
                  //  短信验证码一分钟后输入框设置为空，提示验证码过期，倒计时更改为获取验证码。
                  this.countDownTime = 0;
                  this.btntxt = '获取短信验证码';
                  this.showPhoneCaptchaButton=false;
              }
          },

          getBorrowIntention(){
              this.$refs.addBorrowForm.validate((valid) => {


                  if (valid) {
                      var that=this;
                      let param = Object.assign({}, this.addBorrowForm);
                      reqDirectBorrowIntentionAdd(param).then((res) => {
                              if(res.data.code===2){
                                  that.$message({
                                      message: '验证码失效',
                                      type: 'error'
                                  });
                                return false;
                              }
                              if(res.data.code===3){
                                  that.$message({
                                      message: '验证码错误',
                                      type: 'error'
                                  });
                                return false;
                              }
                          if(res.data.code===4){
                              that.$message({
                                  message: '手机验证码失效',
                                  type: 'error'
                              });
                              return false;
                          }
                          if(res.data.code===5){
                              that.$message({
                                  message: '手机验证码错误',
                                  type: 'error'
                              });
                              return false
                          }
                              if (res.data.code === 1) {
                                that.dialogMsgVisible=true;
                                  that.$refs.addBorrowForm.resetFields();
                                  that.addBorrowForm.codeImg='';
                                  that.clickCodeImage=false;
                                  that.inputCodeImage=false;
                                  this.countDownTime = 0;
                                  this.btntxt = '获取短信验证码';
                                  this.showPhoneCaptchaButton=false;
                                  that.dialogFormBorrowVisible=false;
                              }
                              if (res.data.code === 0) {
                                  that.$message({
                                      message: '提交失败',
                                      type: 'error'
                                  })
                              }
                          });
                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          },

        getLanIntention(){
            this.$refs.addLanForm.validate((valid) => {
                if (valid) {
                    var that=this;
                    let param = Object.assign({}, this.addLanForm);
                    reqDirectLoanIntentionAdd(param).then((res) => {
                        if(res.data.code===0) {
                          that.$message({
                            message: res.data.msg,
                            type: 'error'
                          });
                        }
                        if (res.data.code === 1) {
                          that.dialogMsgVisible=true;
                          that.$refs.addLanForm.resetFields();
                          that.addLanForm.codeImg='';
                          that.clickCodeImage=false;
                          that.inputCodeImage=false;
                          that.countDownTime = 0;
                          that.btntxt = '获取短信验证码';
                          that.showPhoneCaptchaButton=false;
                          that.dialogFormLanVisible=false;
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getBorrowIntentionCode(){
            reqDirectBorrowIntentionCodeImg().then((res)=>{
              if(res.data.code===1){
                var imgName=res.data.data.fileName;
                document.getElementById("imgCode").src=downloadFileURL+imgName+'.jpg/';
                this.addBorrowForm.onlyImgCode=res.data.data.onlyImgCode;
              }

            })

        },
        getLanIntentionCode(){
          reqDirectLanIntentionCodeImg().then((res)=>{
               if(res.data.code===1){
                 var imgName=res.data.data.fileName;
                 document.getElementById("loanIntentionImgCode").src=downloadFileURL+imgName+'.jpg/'
                 this.addLanForm.onlyImgCode=res.data.data.onlyImgCode;
               }

            })

        },
        register(){
            this.$router.push({name:'register'});
        },
        login(){
            this.$router.push({name:'login'});
        },

        scroll(){
           this.animate=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
           setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                   this.notificationAnnouncementArray.push(this.notificationAnnouncementArray[0]);  // 将数组的第一个元素添加到数组的
                   this.notificationAnnouncementArray.shift();               //删除数组的第一个元素
                   this.animate=false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
           },500)
        },

// 首页banner
          getBannerImages(){
            reqBannerImage().then((res)=>{
                if(res.data.code===1){
                    this.bannerImageArray=res.data.data
                }
            })
          },
// banner图片上的统计
        getBannerStatistical(){
          reqBannerStatistical().then((res)=>{
            if(res.data.code===1){
              this.bodyDefaultMsg=res.data.data[0].content
            }else {
              this.bodyDefaultMsg='<p>抱歉，暂无数据</p>'
            }
          })
        },

 // 焦点新闻轮播图：
          getFocusNewsImages(){
              reqFocusNewsImages().then((res)=>{
                  if(res.data.code===1){
                      this.focusNewsImagesArray=res.data.data.referenceCenterFocusList;
                      this.focusNewsImagesCount=res.data.data.focusNewsImagesCount
                  }
              })
          },

 // 焦点类标题：
          getFocusTitle(){
              reqFocusTitle().then((res)=>{
                  if(res.data.code===1){
                      this.focusTitleArray=res.data.data.referenceCenterFocusSubjectList;
                      this.focusTitle=res.data.data.referenceCenterFocusSubjectListFirst;
                  }else {
                      this.focusTitle='抱歉，暂无数据'
                  }
              })
          },
 // 通知公告滚动：
          getNotificationAnnouncement(){
              reqNotificationAnnouncement().then((res)=>{
                  if(res.data.code===1){
                      this.notificationAnnouncementArray=res.data.data.notificationAnnouncementList;
                      this.notificationAnnouncementCount=res.data.data.notificationAnnouncementCount;
                  }
              })
          },

        getTopNBorrowProjects(){
          let para = {
            orderBy: 'publish_time',
            rowCounts: 6
          };
          reqGetTopNBorrowProjects(para).then((res)=>{
            if(res.data.code===1){
              this.borrowProjectArray=res.data.data
            }
          });
        },
        getTopNLoanProjects(){
          let para = {
            orderBy: 'publish_time',
            rowCounts: 6
          };
          reqGetTopNLoanProjects(para).then((res)=>{
            if(res.data.code===1){
              this.loanProjectArray=res.data.data
            }
          });
        },

//      格式化项目状态
        getRealTimeStatsName(row, column){
          if(row.realTimeStatusName==0){
            return '对接中'
          }else if(row.realTimeStatusName==1){
            return '已完成'
          }else if(row.realTimeStatusName==2){
            return '已过期'
          }
        },
// 政策法规,借贷知识：
        getPoliciesRegulations(){
          reqPoliciesRegulations().then((res)=>{
            if(res.data.code===1){
              this.policiesRegulationsArray=res.data.data.policiesRegulationsList;
              this.policiesRegulationsCount=res.data.data.policiesRegulationsCount;
              this.borrowingKnowledgeArray=res.data.data.borrowingKnowledgeList;
              this.borrowingKnowledgeCount=res.data.data.borrowingKnowledgeCount;
            }
          })
        },
// 首页伙伴
        getHomePagePartner(){
          reqHomePagePartner().then((res)=>{
            if(res.data.code===1){
              this.homePagePartnerHtml=res.data.data[0].content
            }else {
              this.homePagePartnerHtml='<p>抱歉，暂无数据</p>'
            }
          })
        },
        goBorrowProjectDetail(index,row){
          reqValidateWebUser({}).then((res) =>{
            if(res.data.code == 1)
              this.$router.push({name: 'borrowProjectDetail', query: {id: row.id}});
            else
              this.dialogProjectVisible=true;
          });
        },

        goLanProjectDetail(index,row){
          reqValidateWebUser({}).then((res) =>{
            if(res.data.code == 1)
              this.$router.push({name: 'loanProjectDetail', query: {id:  row.id}});
            else
              this.dialogProjectVisible=true;
          });

        },
        goLogin(){
          this.dialogProjectVisible=false;
          this.$router.push({path:'/login'})
        },
        getRegister(){
          this.dialogProjectVisible=false;
          this.$router.push({path:'/register'})
        },
        toCenterNewsDetail(id){
          this.$router.push({path:'centerNewsDetail',query:{id:id,total:this.focusNewsImagesCount}})
        },
        toNotificationAnnouncement(id){
          this.$router.push({path:'notificationAnnouncementDetail',query:{id:id,total:this.notificationAnnouncementCount}})
        },
        toReferenceCenterListByPublishType(publishType){
          if(publishType==='交流合作'){
            this.$router.push({path:'communicationCooperation'})
          }else if(publishType==='投资快讯'){
            this.$router.push({path:'investmentExpress'})
          }else if(publishType==='行业资讯'){
            this.$router.push({path:'industryInformation'})
          }else if(publishType==='中心新闻'){
            this.$router.push({path:'centerNews'})
          }
        },
        toReferenceCenterAnyWhereDetail(id,publishType){
          reqReferenceCenterPublishTypeCount({id:id}).then((res)=>{
            if(res.data.code===1){
              this.publishTypeTotal=res.data.data;
              if(publishType==='交流合作'){
                this.$router.push({path:'communicationCooperationDetail',query:{id:id,total:this.publishTypeTotal}})
              }else if(publishType==='投资快讯'){
                this.$router.push({path:'investmentExpressDetail',query:{id:id,total:this.publishTypeTotal}})
              }else if(publishType==='行业资讯'){
                this.$router.push({path:'industryInformationDetail',query:{id:id,total:this.publishTypeTotal}})
              }else if(publishType==='中心新闻'){
                this.$router.push({path:'centerNewsDetail',query:{id:id,total:this.publishTypeTotal}})
              }
            }
          });
        },
        toPoliciesRegulationsDetail(id){
          this.$router.push({path:'policiesRegulationsDetail',query:{id:id,total:this.policiesRegulationsCount}})
        },
        toBorrowingKnowledgeDetail(id){
          this.$router.push({path:'borrowingKnowledgeDetail',query:{id:id,total:this.borrowingKnowledgeCount}})
        },
        getFileManagementList(){
          reqFileManagementList().then(res=>{
            for(var i=0;i<res.data.data.length;i++){
              if(res.data.data[i].fileSize<1024){
                res.data.data[i].fileSize=res.data.data[i].fileSize.toFixed(2).toString()+'byte'
              } else if(res.data.data[i].fileSize>1024){
                res.data.data[i].fileSize=(res.data.data[i].fileSize/1024).toFixed(2).toString()+'KB'
              }else{
                res.data.data[i].fileSize=(res.data.data[i].fileSize/1024/1024).toFixed(2).toString()+'MB'
              }
            }
            this.fileManagementArray=res.data.data;
          })
        }
    },
    mounted () {
        this.$store.dispatch('showHF');
        this.getBannerImages();
        this.getBannerStatistical();
        this.getFocusNewsImages();
        this.getFocusTitle();
        this.getNotificationAnnouncement();
        this.getTopNBorrowProjects();
        this.getTopNLoanProjects();
        this.getPoliciesRegulations();
        this.getHomePagePartner();
        this.getFileManagementList();
//          this.$store.commit('switch_dialog');
    }
  }

</script>
<style slot-scope="scope">
  .transparent {
    pointer-events: none;
    filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
    -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
    opacity: 0.5; /*其他，透明度50%*/
  }
  .disabledChangeCodeImage{
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue